import { makeStyles } from "@material-ui/core";

const MuiStylesEmptyState = makeStyles((theme) => ({
	container: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		paddingBottom: "50px",
	},
	card: {
		backgroundColor: "white",
		borderRadius: "16px",
		boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
		marginTop: "-35px",
		cursor: "pointer",
		padding: "12px 14px",
		minHeight: "calc(30vh - 300px)",
		width: "90%",
		display: "flex",
		flexDirection: "column",
		gap: "8px",
	},
	iconContainer: {
		display: "flex",
		justifyContent: "center",
	},
	icon: {
		fontSize: "4rem",
		color: "#CCCCCC",
	},
	titleContainer: {
		textAlign: "center",
	},
	title: {
		fontSize: "24px",
		lineHeight: "1.1",
		fontWeight: 500,
	},
	subtitleContainer: {
		textAlign: "center",
	},
	subtitle: {
		color: "rgba(0, 0, 0, 0.7)",
	},
	instructionsTitle: {
		fontWeight: 600,
	},
	instructionsList: {
		paddingLeft: "20px",
		margin: 0,
		color: "rgba(0, 0, 0, 0.7)",
	},
	buttonContainer: {
		display: "flex",
		justifyContent: "center",
	},
	button: {
		backgroundColor: "#2F7EF7",
		borderRadius: "30px",
		padding: "8px",
		width: "80%",
		height: "2.5rem",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#1E6FE6",
		},
	},
}));

export default MuiStylesEmptyState;

